// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3g-1";
export var movingGradient = "_3g-4";
export var movingGradientBlock = "_3g-2";
export var skeleton = "_3g-0";
export var skeletonText = "_3g-3";